/**
 * React Query keys for provider-approvals and pending-approvals.
 * Shared by Approval Requests page and useApprovalsPush so cache invalidation stays in sync.
 */

/** Key for the provider-map-approvals list (per clinician). */
export const PROVIDER_MAP_APPROVALS_QUERY_KEY = 'provider-map-approvals';

/** Key for linked providers (office admin dropdown). */
export const LINKED_PROVIDERS_QUERY_KEY = 'linked-providers';

/** Key for pending-approvals-summary (nav bell count). */
export const PENDING_APPROVALS_SUMMARY_QUERY_KEY = 'pending-approvals-summary';
